<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6">
      <h1 class="text-center">Panel de Configuración</h1>
      <h1>Modelos</h1>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body :key="models.length">
            <b-tabs content-class="mt-3">
              <b-tab title="Modelos" active>
                  <b-card-header class="header-card-wrapper border-0">
                    <router-link
                      class="btn mb-3 btn-primary px-4"
                      :to="{
                        name: 'modelosNew',
                      }"
                      >
                      Agregar modelo
                    </router-link>
                    <base-input
                      type="text"
                      placeholder="Buscar"
                      v-model="search"
                      style="max-width: 300px !important; margin-left: 20px;"
                    >
                    </base-input>
                  </b-card-header>

                  <el-table class="table-responsive table"
                            header-row-class-name="thead-light"
                            :data="pagedTableData"
                            :key="models.length">
                      <el-table-column label="Id Modelo"
                                prop="name"
                                width="150px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'modelosEdit',
                                    params: { modelsId: row.id },
                                  }">
                                      {{row.id}}
                                </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Tipo"
                                prop="name"
                                width="200px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.type.name}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Nombre"
                                prop="name">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.name}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Marca"
                                prop="brand">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.brand ? row.brand.name : ''}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Género"
                                prop="gender">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.gender ? row.gender.name: ''}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="50px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'modelosEdit',
                                    params: { modelsId: row.id },
                                  }">
                                      <img src="img/theme/icn_edit.svg" alt="">
                                  </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="80px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <a class="page-link" v-on:click="deleteElement(row.id), delete models[row.id]"><img src="img/theme/icn_delete.svg" alt=""></a>
                              </b-media>
                          </template>
                      </el-table-column>
                  </el-table>
                  <b-card-footer class="py-4 d-flex justify-content-end">
                      <base-pagination v-model="currentPage" :per-page="pageSize" @change="setPage" :total="models.length"></base-pagination>
                  </b-card-footer>

              </b-tab>
              <b-tab title="Marcas">
                <b-card-header class="header-card-wrapper border-0">
                    <router-link
                      class="btn mb-3 btn-primary px-4"
                      :to="{
                        name: 'marcasNew',
                      }"
                      >
                      Agregar marca
                    </router-link>
                    <base-input
                      type="text"
                      placeholder="Buscar"
                      v-model="searchBrand"
                      style="max-width: 300px !important; margin-left: 20px;"
                    >
                    </base-input>
                  </b-card-header>

                  <el-table class="table-responsive table"
                            header-row-class-name="thead-light"
                            :data="pagedTableDataBrands"
                            :key="colors.length">
                      <el-table-column label="Id Marca"
                                prop="name"
                                width="150px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'marcasEdit',
                                    params: { brandsId: row.id },
                                  }">
                                      {{row.id}}
                                </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Nombre"
                                prop="name"
                                width="200px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.name}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="50px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'marcasEdit',
                                    params: { brandsId: row.id },
                                  }">
                                      <img src="img/theme/icn_edit.svg" alt="">
                                  </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="80px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <a class="page-link" v-on:click="deleteElementBrand(row.id), delete brands[row.id]"><img src="img/theme/icn_delete.svg" alt=""></a>
                              </b-media>
                          </template>
                      </el-table-column>
                  </el-table>
                  <b-card-footer class="py-4 d-flex justify-content-end">
                      <base-pagination v-model="currentPageBrand" :per-page="pageSize" @change="setPageBrand" :total="brands.length"></base-pagination>
                  </b-card-footer>

              </b-tab>
              <b-tab title="Colores">
                <b-card-header class="header-card-wrapper border-0">
                    <router-link
                      class="btn mb-3 btn-primary px-4"
                      :to="{
                        name: 'coloresNew',
                      }"
                      >
                      Agregar color
                    </router-link>
                    <base-input
                      type="text"
                      placeholder="Buscar"
                      v-model="searchColor"
                      style="max-width: 300px !important; margin-left: 20px;"
                    >
                    </base-input>
                  </b-card-header>

                  <el-table class="table-responsive table"
                            header-row-class-name="thead-light"
                            :data="pagedTableDataColor"
                            :key="colors.length">
                      <el-table-column label="Id Color"
                                prop="name"
                                width="150px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'coloresEdit',
                                    params: { colorsId: row.id },
                                  }">
                                      {{row.id}}
                                </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Nombre"
                                prop="name"
                                width="200px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.name}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="50px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'coloresEdit',
                                    params: { colorsId: row.id },
                                  }">
                                      <img src="img/theme/icn_edit.svg" alt="">
                                  </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="80px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <a class="page-link" v-on:click="deleteElementColor(row.id), delete colors[row.id]"><img src="img/theme/icn_delete.svg" alt=""></a>
                              </b-media>
                          </template>
                      </el-table-column>
                  </el-table>
                  <b-card-footer class="py-4 d-flex justify-content-end">
                      <base-pagination v-model="currentPageColor" :per-page="pageSize" @change="setPageColor" :total="colors.length"></base-pagination>
                  </b-card-footer>

              </b-tab>
              <b-tab title="Colores de Bordado">
                <b-card-header class="header-card-wrapper border-0">
                    <router-link
                      class="btn mb-3 btn-primary px-4"
                      :to="{
                        name: 'threadsNew',
                      }"
                      >
                      Agregar color
                    </router-link>

                  </b-card-header>

                  <el-table class="table-responsive table"
                            header-row-class-name="thead-light"
                            :data="pagedTableDataThreadColor"
                            :key="threadColors.length">
                      <el-table-column label="Id Color"
                                prop="name"
                                width="150px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'threadsEdit',
                                    params: { colorsId: row.id },
                                  }">
                                      {{row.id}}
                                </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Nombre"
                                prop="name"
                                width="200px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.name}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="50px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'threadsEdit',
                                    params: { colorsId: row.id },
                                  }">
                                      <img src="img/theme/icn_edit.svg" alt="">
                                  </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="80px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <a class="page-link" v-on:click="deleteElementThreadColor(row.id), delete threadsColors[row.id]"><img src="img/theme/icn_delete.svg" alt=""></a>
                              </b-media>
                          </template>
                      </el-table-column>
                  </el-table>
                  <b-card-footer class="py-4 d-flex justify-content-end">
                      <base-pagination v-model="currentPageThreadColor" :per-page="pageSize" @change="setPageThreadColor" :total="threadColors.length"></base-pagination>
                  </b-card-footer>
              </b-tab>
              <b-tab title="Fuentes de Bordado">
                <b-card-header class="header-card-wrapper border-0">
                    <router-link
                      class="btn mb-3 btn-primary px-4"
                      :to="{
                        name: 'fontsNew',
                      }"
                      >
                      Agregar fuente
                    </router-link>

                  </b-card-header>

                  <el-table class="table-responsive table"
                            header-row-class-name="thead-light"
                            :data="pagedTableDataFonts"
                            :key="fonts.length">
                      <el-table-column label="Id Fuente"
                                prop="name"
                                width="150px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'fontsEdit',
                                    params: { fontsId: row.id },
                                  }">
                                      {{row.id}}
                                </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label="Nombre"
                                prop="name"
                                width="200px">
                          <template v-slot="{row}">
                              <b-media no-body class="align-items-center">
                                  {{row.name}}
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="50px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <router-link
                                  :to="{
                                    name: 'fontsEdit',
                                    params: { fontsId: row.id },
                                  }">
                                      <img src="img/theme/icn_edit.svg" alt="">
                                  </router-link>
                              </b-media>
                          </template>
                      </el-table-column>
                      <el-table-column label=""
                                prop=""
                                width="80px"
                                style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                          <template v-slot="{row}" style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                              <b-media no-body class="align-items-center">
                                <a class="page-link" v-on:click="deleteElementFonts(row.id), delete fonts[row.id]"><img src="img/theme/icn_delete.svg" alt=""></a>
                              </b-media>
                          </template>
                      </el-table-column>
                  </el-table>
                  <b-card-footer class="py-4 d-flex justify-content-end">
                      <base-pagination v-model="currentPageFonts" :per-page="pageSize" @change="setPageFonts" :total="fonts.length"></base-pagination>
                  </b-card-footer>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    data() {
      return {
        models: [],
        colors: [],
        threadColors: [],
        brands: [],
        fonts: [],
        token:'',
        user:'',
        currentPage: 1,
        pageSize: 10,
        reload: 0,
        search: '',
        currentPageColor: 1,
        currentPageThreadColor: 1,
        currentPageBrand: 1,
        currentPageFonts: 1,
        searchColor: '',
        searchBrand: ''

      };
    },
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    created () {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.models) {
          console.log(response.data)
          let temp = [], tempColor = [], tempThreadColors = [], tempBrands = [], tempFonts = []
          Object.keys(response.data.models).map((key) => [response.data.models[key]]).map(function(value) {
            temp.push(value[0])
          })
          Object.keys(response.data.colors).map((key) => [response.data.colors[key]]).map(function(value) {
            tempColor.push(value[0])
          })
          Object.keys(response.data.threadcolors).map((key) => [response.data.threadcolors[key]]).map(function(value) {
            tempThreadColors.push(value[0])
          })
          Object.keys(response.data.brands).map((key) => [response.data.brands[key]]).map(function(value) {
            tempBrands.push(value[0])
          })
          Object.keys(response.data.fonts).map((key) => [response.data.fonts[key]]).map(function(value) {
            tempFonts.push(value[0])
          })
          this.models = temp
          this.brands = tempBrands
          this.colors = tempColor
          this.threadColors =  tempThreadColors
          this.fonts =  tempFonts
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    computed: {
      pagedTableData() {
        // data.brand.name.toLowerCase().includes(this.search.toLowerCase())
        return this.models.filter(data => this.search ? data.name.toLowerCase().includes(this.search.toLowerCase()) || data.type.name.toLowerCase().includes(this.search.toLowerCase()) : data).slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
      },
      pagedTableDataBrands() {
        return this.brands.filter(data => this.searchBrand ? data.name.toLowerCase().includes(this.searchBrand.toLowerCase()) : data).slice(this.pageSize * this.currentPageBrand - this.pageSize, this.pageSize * this.currentPageBrand)
      },
      pagedTableDataColor() {
        return this.colors.filter(data => this.searchColor ? data.name.toLowerCase().includes(this.searchColor.toLowerCase()) : data).slice(this.pageSize * this.currentPageColor - this.pageSize, this.pageSize * this.currentPageColor)
      },
      pagedTableDataThreadColor() {
        return this.threadColors.filter(data => data).slice(this.pageSize * this.currentPageThreadColor - this.pageSize, this.pageSize * this.currentPageThreadColor)
      },
      pagedTableDataFonts() {
        return this.fonts.filter(data => data).slice(this.pageSize * this.currentPageFonts - this.pageSize, this.pageSize * this.currentPageFonts)
      }
    },
    methods : {
      setPage (val) {
        this.currentPage = val
      },
      setPageBrand (val) {
        this.currentPageBrand = val
      },
      setPageColor (val) {
        this.currentPageColor = val
      },
      setPageThreadColor (val) {
        this.currentPageThreadColor = val
      },
      setPageFonts (val) {
        this.currentPageFonts = val
      },
      deleteElement(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.models.findIndex(x => x.id === index)

        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_model',
            m_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.models.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      },
      deleteElementBrand(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.brands.findIndex(x => x.id === index)

        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_brand',
            c_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.brands.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      },
      deleteElementColor(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.colors.findIndex(x => x.id === index)

        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_color',
            c_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.colors.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      },
      deleteElementThreadColor(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.threadColors.findIndex(x => x.id === index)

        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_threadcolor',
            c_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.threadColors.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      },
      deleteElementFonts(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.fonts.findIndex(x => x.id === index)

        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_font',
            f_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.fonts.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  };
</script>
<style>
.el-table, a{
  color: #112357;
}
.el-table_1_column_5,
.el-table_1_column_6,
.el-table_3_column_13,
.el-table_3_column_14{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.el-table a,
.el-table a:hover,
.el-table a:focus{
  border: none !important;
  background: none !important;
}
.header-card-wrapper .form-control{
  max-width: 300px;
}
</style>
